import type { AxiosRequestConfig } from "axios";
import type { CohesiveAPIClient } from "../../client";
import type {
  BetaInviteCodeAdminListItem,
  CreateBetaInviteCodePayload,
  CreateBetaInviteCodeResponse,
  ListBetaInviteCodesParams,
  ListBetaInviteCodesResponse,
  UpdateBetaInviteCodePayload,
  UpdateBetaInviteCodeResponse,
} from "./types";

export * from "./types";

const ENDPOINT = "/api/v2/admin/beta-invite-codes";

export class AdminBetaInviteCodesAPI {
  constructor(private client: CohesiveAPIClient) {}

  async list(
    params?: ListBetaInviteCodesParams,
    config?: AxiosRequestConfig,
  ): Promise<BetaInviteCodeAdminListItem[]> {
    const sp = new URLSearchParams();
    if (params?.tags?.length) {
      for (const t of params.tags) {
        const trimmed = t.trim();
        if (trimmed) {
          sp.append("tag", trimmed);
        }
      }
    }
    if (params?.q?.trim()) {
      sp.set("q", params.q.trim());
    }
    const qs = sp.toString();
    const url = qs ? `${ENDPOINT}?${qs}` : ENDPOINT;
    const response = await this.client.axios.get<ListBetaInviteCodesResponse>(
      url,
      config,
    );
    return response.data.data.invite_codes;
  }

  async create(
    payload: CreateBetaInviteCodePayload,
    config?: AxiosRequestConfig,
  ): Promise<BetaInviteCodeAdminListItem> {
    const response = await this.client.axios.post<CreateBetaInviteCodeResponse>(
      ENDPOINT,
      payload,
      config,
    );
    return response.data.data.invite_code;
  }

  async update(
    id: string,
    payload: UpdateBetaInviteCodePayload,
    config?: AxiosRequestConfig,
  ): Promise<BetaInviteCodeAdminListItem> {
    const response = await this.client.axios.put<UpdateBetaInviteCodeResponse>(
      `${ENDPOINT}/${encodeURIComponent(id)}`,
      payload,
      config,
    );
    return response.data.data.invite_code;
  }

  async expire(id: string, config?: AxiosRequestConfig): Promise<void> {
    await this.client.axios.post(
      `${ENDPOINT}/${encodeURIComponent(id)}/expire`,
      {},
      config,
    );
  }

  async deleteInvite(id: string, config?: AxiosRequestConfig): Promise<void> {
    await this.client.axios.delete(
      `${ENDPOINT}/${encodeURIComponent(id)}`,
      config,
    );
  }
}
